import {AxiosRequestConfig} from 'axios';
import {AuthRequest, AuthResponse, RegisterRequest, RegisterResponse, ResetPasswordRequest} from './authModel';
import {ErrorResponse} from "../models/error-response";
import {User} from "../../core/models/user";
import {get, instance, post} from "../core";

const cookieOnlyConfig = (): AxiosRequestConfig => {
  const adapter = instance.defaults.adapter!;
  return {
    adapter: config => {
      // Axios 0.21 merges default headers and sends even null/undefined values.
      // Remove the flattened header at the transport boundary, not from shared defaults.
      Object.keys(config.headers || {}).forEach(name => {
        if (name.toLowerCase() === 'authorization') {
          delete config.headers[name];
        }
      });
      return adapter(config);
    },
  };
};

export const createAuthApi = () => {

  const login = (
    credentials: AuthRequest
  ): Promise<AuthResponse & ErrorResponse> => {
    return post('/auth/signin', credentials, cookieOnlyConfig());
  };

  const loginWithGoogle = (
    credential: string
  ): Promise<AuthResponse & ErrorResponse> => {
    return post('/auth/google', {credential: credential}, cookieOnlyConfig());
  };

  const me = (): Promise<User & ErrorResponse> => {
    return get('/auth/me');
  };

  const refreshToken = (): Promise<AuthResponse & ErrorResponse> => {
    return get('/auth/refresh-token', undefined, cookieOnlyConfig());
  };

  const register = (
    credentials: RegisterRequest
  ): Promise<RegisterResponse & ErrorResponse> => {
    return post('/auth/register', credentials);
  };

  const resetPassword = (
    email: string
  ): Promise<RegisterResponse & ErrorResponse> => {
    return post('/auth/reset-password', {email});
  };

  const confirmResetPassword = (
    token: string,
    credentials: ResetPasswordRequest
  ): Promise<RegisterResponse & ErrorResponse> => {
    return post(`/auth/reset-password/confirmation/${encodeURIComponent(token)}`, credentials, cookieOnlyConfig());
  };

  const logout = (): Promise<ErrorResponse> => {
    return post('/auth/signout', undefined, cookieOnlyConfig());
  };

  return {
    refreshToken,
    login,
    loginWithGoogle,
    me,
    register,
    logout,
    resetPassword,
    confirmResetPassword,
  };
};
